import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  row: {
    '&&': {
      border: 'unset',
    },
  },
  cell: {
    '&&': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  collapsedContent: {
    margin: SPACES.xxs,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,
  },

  collapsedItem: {
    display: 'flex',
    gap: SPACES.xl,
  },
  itemText: {
    '&&': {
      fontSize: '14px',
      width: 200,
      flex: '0 0 auto',
    },
  },
  map: {
    width: '100%',
    height: 400,
    borderRadius: 10,
    overflow: 'hidden',
  },

  mediaList: {
    display: 'flex',
    gap: SPACES.m,
    flexWrap: 'wrap',
  },
  image: {
    '&&': {
      display: 'block',

      borderRadius: 5,
      objectFit: 'cover',

      width: '80px',
      height: '80px',
      fill: theme.palette.custom.darkBlue2,
    },
  },
  imageIconWrapper: {
    display: 'flex',
    gap: SPACES.xs,
  },

  link: {
    display: 'flex',
    gap: SPACES.xxxs,
    alignItems: 'center',

    wordBreak: 'break-all',
  },
  linkIcon: {
    minWidth: 16,
    width: 16,
    height: 'auto',
  },
  copyIcon: {
    minWidth: 12,
    width: 12,
    height: 'auto',
  },

  impactQuantity: {
    marginTop: '8px',
  },
}))
